import { Loader2 } from "lucide-react";
import { LightTooltip } from "components/light-tooltip";
import { CustomTooltipContent } from "components/tooltip-content";
import { CAMPAIGN_INTERNAL_STATUSES } from "pages/constants";
import { SubmitButton } from "components/SubmitButton";
import { DollarCircle } from "components/icons/components/DollarCircle";

interface SkipDesignSubmitAndPayButtonProps {
  internalStatus: keyof typeof CAMPAIGN_INTERNAL_STATUSES;
  loading: boolean;
  disabled: boolean;
  handleClickSubmitAndPay: () => void;
  isPaymentSkipped: boolean;
  type: "primary" | "secondary";
}

const TooltipContent = () => {
  return (
    <CustomTooltipContent title="Flyer design needed" content="Please upload your flyer design before continue." />
  );
};

export const SkipDesignSubmitAndPayButton = ({
  internalStatus,
  loading,
  disabled,
  handleClickSubmitAndPay,
  isPaymentSkipped,
  type,
}: SkipDesignSubmitAndPayButtonProps) => {
  if (internalStatus !== CAMPAIGN_INTERNAL_STATUSES.DRAFT) {
    return null;
  }

  return (
    <LightTooltip title={TooltipContent()} placement="top">
      <div>
        <SubmitButton
          onClick={handleClickSubmitAndPay}
          disabled={disabled}
          type={type}
          dataCy="skipDesignSubmitAndPayButton"
          icon={loading && isPaymentSkipped ? <Loader2 className="h-5 w-5 animate-spin" /> : <DollarCircle />}
        >
          {!isPaymentSkipped ? "Submit and pay" : "Submit"}
        </SubmitButton>
      </div>
    </LightTooltip>
  );
};
